import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';
import Placeholder from '../../../common/placeholder/Placeholder';
import Slider from '../../../common/Slider/Slider';

const imgBaseUrl = 'https://a1media.antena1.com.br/image/artista/300x600/';
const urlArtists = '/artistas/';
const defaultA1Vertical = '/thumbnail_Default-Vertical.jpg';

const ArtistsSlider = ({ dataArtistsSlider, withTitle, autoPlay, device, fetchArtistsSlidesIfNeeded }) => {
    useEffect(() => {
        fetchArtistsSlidesIfNeeded();

        setTimeout(() => {
            const event = new Event('resize');

            window.dispatchEvent(event);
        }, 200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const slides = dataArtistsSlider; // Note: the artistSlides are shuffeld by the controller (only if not already fetched by the artists page)

    return (
        slides.length > 1 ? (
            <div className="artists-slider">
                {
                    withTitle &&
                        <header>
                            <h2>Conheça tudo sobre o seu artista favorito</h2>
                            <p className="subtitle">Beyoncé, Bruno Mars, Coldplay, Céline Dion, Imagine Dragons e muito mais</p>
                        </header>
                }
                <Slider
                    autoplay={autoPlay ? { delay: 1000 } : false}
                    slidesPerView={1.05}
                    navigation={device === 'desktop'}
                    centeredSlides={false}
                    initialSlide={0}
                    breakpoints={{
                        320: {
                            slidesPerView: 2.2,
                            spaceBetween: 8,
                        },
                        576: {
                            slidesPerView: 3.2,
                            spaceBetween: 12,
                        },
                        768: {
                            slidesPerView: 4,
                            spaceBetween: 16,
                        },
                        992: {
                            slidesPerView: 5,
                            spaceBetween: 16,
                        },
                        1200: {
                            slidesPerView: 6,
                            spaceBetween: 16,
                        },
                    }}
                >
                    {
                        slides.map((item) => (
                            <ul key={item.Nam} className="artists-banner d-flex">
                                <li className="">
                                    <Button
                                        title={`Biografia de ${item.Nam} `}
                                        to={urlArtists + item.Url}
                                    >
                                        <div className="artistCard" style={{ backgroundImage: `url(${defaultA1Vertical})` }}>
                                            <img
                                                alt={item.Nam}
                                                src={imgBaseUrl + item.Ver}
                                                loading="lazy"
                                            />
                                            <div className="artistsName">
                                                <h4>
                                                    {item.Nam}
                                                </h4>
                                            </div>
                                        </div>
                                    </Button>
                                </li>
                            </ul>
                        ))
                    }
                </Slider>
                {
                    withTitle && (
                        <div className="containerButton">
                            <Button className="btnMoreArtist" title="Ir para a página promoções" to="/artistas">Ver mais artistas</Button>
                        </div>
                    )
                }
            </div>
        ) : (
            <Placeholder minHeight="400px" />
        )
    );
};

ArtistsSlider.propTypes = exact({
    dataArtistsSlider: PropTypes.arrayOf(PropTypes.object).isRequired,
    fetchArtistsSlidesIfNeeded: PropTypes.func.isRequired,
    withTitle: PropTypes.bool,
    autoPlay: PropTypes.bool,
    device: PropTypes.string,
});

export default ArtistsSlider;
